import useLogout from 'hooks/useLogout';

let timeoutHandler = null;

export default () => {
  const performLogout = useLogout();

  function logTheUserOut() {
    window.localStorage.removeItem('logoutTimestamp');
    performLogout(
      'Hi! We’ve logged you out because we thought you might have moved away from your device. You can log back in below or close this window if you’re finished.',
    );
  }

  return (timeout) => {
    const prevTimeout = window.localStorage.getItem('logoutTimestamp');

    clearTimeout(timeoutHandler);
    if (timeout > 0) {
      if (prevTimeout && Date.now() - prevTimeout >= timeout) {
        logTheUserOut();
        return;
      }

      window.localStorage.setItem('logoutTimestamp', Date.now() + timeout);

      timeoutHandler = setTimeout(logTheUserOut, timeout);
    } else {
      window.localStorage.removeItem('logoutTimestamp');
    }
  };
};
